// src/config.js

// 优先使用环境变量，如果没有则使用默认值（开发环境或测试环境）
const API_BASE_URL = process.env.REACT_APP_TPES_API_BASE_URL || 'https://tpesapi3.properson.cn';
const API_TOKEN = process.env.REACT_APP_TPES_API_TOKEN || '62398b03-b29a-4b53-8270-478fe39e3545-adsk78214566ASE12456';

// LocalStorage Keys
// 集中管理 Key，防止拼写错误
const STORAGE_KEYS = {
  USER_INFO: 'userInfo',
  ACTIVE_SESSION: 'activeAssessmentSession',
  PENDING_SUBMISSION: 'pendingAssessmentSubmission',
  UNSYNCED_ANSWERS: 'unsyncedAssessmentAnswers',
  QUIZ_ANSWERS: 'quizAnswers',
  USER_EVALUATION_SESSIONS: 'userEvaluationSessions',
  START_TIME: 'startTime',
  TIME_TAKEN: 'timeTaken',
  COMPLETED_EVALUATIONS: 'completedEvaluations',
  // 注意：quizOrder 是动态 key，通常是 `quizOrder_${lang}`，这里只定义前缀或在代码中动态拼接
  QUIZ_ORDER_PREFIX: 'quizOrder_',
  ASSESSMENT_TYPE: 'assessmentType',
};

export {
  API_BASE_URL,
  API_TOKEN,
  STORAGE_KEYS
};
